import { Radio, FormControlLabel as MuiFormControlLabel } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import AirlineImg from 'components/AirlineLogo';

export const FlightContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  align-items: center;
`;

export const AirlineName = styled.span`
  font-size: 14px;
  color: ${ColorPalette.HEX.DimGray2};
  margin-left: 8px;
`;

export const AirlineLogo = styled(AirlineImg)`
  width: 24px;
  margin-left: 8px;
`;

export const AirlineRadioWrapper = styled.div`
  display: flex;
  align-items: center;
  grid-column: span 5 / span 5;
`;

export const FormControlLabel = styled(MuiFormControlLabel)`
  && {
    margin: 0;
    padding: 0;
  }
`;

export const RadioButton = styled(Radio)`
  &&& {
    padding: 0;

    & .MuiSvgIcon-root {
      color: ${ColorPalette.HEX.OriolesOrange};
      font-size: 18px;
    }

    & .Mui-checked {
      color: ${ColorPalette.HEX.OriolesOrange} !important;
    }
  }
`;

export const FlightTimeText = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${ColorPalette.HEX.PineTree2};
`;

export const FlightLineWrapper = styled.div`
  grid-column: span 2 / span 2;
  display: flex;
  justify-content: center;

  > * {
    width: 50px;
  }
`;

export const FlightLuggages = styled.div`
  display: flex;

  > * + * {
    margin-left: 1px;
  }
`;

export const FlightLuggagesContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ExpandMoreButton = styled.button<{ rotated?: boolean }>`
  all: unset;
  display: flex;
  appearance: none;
  margin-left: 8px;
  cursor: pointer;

  ${(props) =>
    props.rotated &&
    css`
      transform: rotate(180deg);
    `}
`;

export const TurnDays = styled.span`
  position: absolute;
  right: -15px;
  top: -10px;
  width: 15px;
  font-size: 10px;
  text-align: left;
  color: ${({ theme }) => theme.cardFlight.primary};
`;

export const FlightTimeArrivalWrapper = styled.div`
  position: relative;
`;
